import React, { useEffect, useRef } from "react";
import "./roadmap.scss";
import Header from "../landing/Header/Header";
import Sevenphases from "./Sevenphases";
import Getapp from "./Getapp";
import Footer from "../landing/footer/Footer";
import { Breadcrumb } from "react-bootstrap";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Roadmap = () => {
  const textRef = useRef(null);
  const paraRef = useRef(null);
  useEffect(() => {
    const tl = gsap.timeline();

    gsap.set(textRef.current, {
      clipPath: "inset(0% 100% 0% 0%)",
      opacity: 1,
    });

    tl.to(textRef.current, {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: 1,
      ease: "power2.out",
    });
  }, []);

  useEffect(() => {
    gsap.fromTo(
      paraRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
    );
  }, []);


  useEffect(() => {
    gsap.from(".breadvrumbcnt, .breadvrumbcntactive", {
      opacity: 0,
      y: 10,
      duration: 0.6,
      stagger: 0.2,
      ease: "power2.out",
    });
  }, []);

  useEffect(() => {
    gsap.fromTo(".fade-element", { x: 100, opacity: 0, }, { x: 0, opacity: 1, duration: 1 });
  }, []);


  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const breadcrumbSchema = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://tomi.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Roadmap", // ✅ Level 2 in JSON
        "item": "https://tomi.com/roadmap"
      }
    ]
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);


  useEffect(() => {
    document.title = "tomi's roadmap - building a better web for everyone  - tomi";

    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Discover tomi's exciting roadmap. Explore upcoming features, product launches, and development milestones."
      );
    } else {
      const newMeta = document.createElement("meta");
      newMeta.name = "description";
      newMeta.setAttribute(
        "content",
        "Discover tomi's exciting roadmap. Explore upcoming features, product launches, and development milestones."
      );
      document.head.appendChild(newMeta);
    }
  }, []);

  return (
    <>
      <Header />
      <section className="mainroadmap">
        <img
          src="\assets\roadmapassets\storagebannerbgmainprent.png"
          alt="backgroundblur"
          className="backgroundblur"
        />

        <div className="innerroadmap">
          <div className="topleft">
            <nav aria-label="breadcrumb">
              <Breadcrumb className="breadcrumbprnt">
                <Breadcrumb.Item className="breadvrumbcnt" href="/">
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item className="breadvrumbcnt" >
                  Company
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  className="breadvrumbcntactive"
                >
                  Roadmap
                </Breadcrumb.Item>
              </Breadcrumb>
            </nav>

            <h1 className="roadmaphead" ref={textRef}>
              Where we’re headed: The future of TOMI is already in motion.
            </h1>
            <p className="roadmappara" ref={paraRef}>
              TOMI’s roadmap lays the foundation for a new kind of digital experience — one where messaging, payments, identity, and ownership come together seamlessly. From core features to open tools and creator infrastructure, we’re building in public and rolling out new capabilities every quarter. Here’s what’s coming next.
            </p>
          </div>
          <div className="topright">
            <img src="/assets/roadmapassets/leftimg.png" alt="img" className="img-fluid roadmaprightimg fade-element" />
          </div>
        </div>
      </section>
      <Sevenphases />
      <Getapp />
      <Footer />
    </>
  );
};

export default Roadmap;
